import { render, staticRenderFns } from "./BankBasicGridDimensionWrapper.vue?vue&type=template&id=3a7d3998&scoped=true&"
import script from "./BankBasicGridDimensionWrapper.vue?vue&type=script&lang=ts&"
export * from "./BankBasicGridDimensionWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./BankBasicGridDimensionWrapper.vue?vue&type=style&index=0&id=3a7d3998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d3998",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
